"use client";
import { Simplify } from "@/prismicio-types";
import { Content } from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";
import { motion } from "framer-motion";

type Props = {
  data: Simplify<Content.ProposedProgramsSectionSliceDefaultPrimary>;
};

export default function ProposedProgramsHeading({ data }: Props) {
  return (
    <>
      <motion.div
        className="font-archivo font-semibold text-5xl text-center leading-16 text-[#033D61] mb-6"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        <PrismicRichText
          field={data.title}
          components={{
            label: ({ node, children }) => {
              if (node.data.label === "Highlight") {
                return <span className="text-secondary">{children}</span>;
              }
              return <span className="text-primary">{children}</span>;
            },
          }}
        />
      </motion.div>
      <motion.div
        className="font-merriweather font-normal text-xl max-w-[846px] leading-8 text-center text-[#033D61] mb-6"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1, delay: 0.3 }}
      >
        <PrismicRichText field={data.sub_title} />
      </motion.div>
    </>
  );
}
